import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
    getOrderDataById,
    orderBulkUpdate,
    orderEasyUpdate
} from '../../../services/clinicPortalServices/orderEditService';
import { bulkApproveReport } from '../../../services/clinicPortalServices/orderSearchService';
import { Autocomplete, TextField } from '@mui/material';
import { ModalStyled } from '../../../theme/customizedStyleComponents';
import { individualTestStatuses, orderStatuses, reportStatuses } from '../../../services/common/optionsData';
import { getUserRole } from '../../../services/common/util';
import toastr from 'toastr';

import GridAutocomplete from '../../common/GridAutocomplete';
export default class OrderBulkStatusPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            status: '',
            reportStatus: '',
            updateReportStatus: false,
            saving: false
        };
    }

    componentDidMount() {
        this.setState({
            status: this.props.type === 'order' ? orderStatuses[0] : individualTestStatuses[0]
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.setState({
                status: this.props.type === 'order' ? orderStatuses[0] : individualTestStatuses[0],
                reportStatus: '',
                updateReportStatus: false,
                saving: false
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSave = () => {
        const ids = this.props.selectedRows.map((row) => row._id);
        this.setState({ saving: true });

        // If report_status is being set to 'final', use the bulk approve endpoint
        if (this.state.updateReportStatus && this.state.reportStatus === 'final') {
            bulkApproveReport({ orderIds: ids }).then((res) => {
                if (res && res.status === 200) {
                    const failed = (res.data || []).filter((r) => !r.success);
                    if (failed.length > 0) {
                        toastr.warning(`${ids.length - failed.length} approved, ${failed.length} failed`);
                    } else {
                        toastr.success(`${ids.length} report(s) approved succesfully`);
                    }
                    // Also update order status if it was changed
                    if (this.state.status) {
                        let params = { ids, status: this.state.status };
                        orderBulkUpdate(params).then(() => {
                            this.props.loadGridData();
                            this.props.handleClose();
                        });
                    } else {
                        this.props.loadGridData();
                        this.props.handleClose();
                    }
                } else {
                    toastr.error('Error approving reports');
                    this.setState({ saving: false });
                }
            }).catch(() => {
                toastr.error('Error approving reports');
                this.setState({ saving: false });
            });
        } else {
            // Standard bulk update for status and/or report_status
            let params = { ids, status: this.state.status };
            if (this.state.updateReportStatus) {
                params.report_status = this.state.reportStatus || null;
            }
            orderBulkUpdate(params).then((response) => {
                toastr.success(`${ids.length} order(s) updated succesfully`);
                this.setState({
                    status: this.props.type === 'order' ? orderStatuses[0] : individualTestStatuses[0],
                    reportStatus: '',
                    updateReportStatus: false,
                    saving: false
                });
                this.props.loadGridData();
                this.props.handleClose();
            }).catch(() => {
                toastr.error('Error updating orders');
                this.setState({ saving: false });
            });
        }
    };

    render() {
        const userRole = getUserRole();
        const isAdminOrSuper = ['SuperAdmin', 'Admin'].includes(userRole);
        let reportStatusOptions = ['', ...reportStatuses];
        if (!isAdminOrSuper) {
            reportStatusOptions = reportStatusOptions.filter((s) => s !== 'final');
        }

        const selectedCount = this.props.selectedRows ? this.props.selectedRows.length : 0;
        const reportStatusEligibleStatuses = ['Pending Review', 'Resulted', 'On Hold'];
        const showReportStatus = reportStatusEligibleStatuses.includes(this.state.status);

        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Bulk Status ({selectedCount} selected)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <GridAutocomplete
                                options={this.props.type === 'order' ? orderStatuses : individualTestStatuses}
                                value={this.state.status}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        status: newValue,
                                        updateReportStatus: false,
                                        reportStatus: ''
                                    });
                                }}
                                getOptionLabel={(option) => (option ? option : '')}
                                renderInput={(params) => <TextField {...params} variant="outlined" label="Order Status *" />}
                            />
                        </div>
                        {showReportStatus && (
                            <div className="col-12 mt-4" style={{ borderTop: '1px solid #dee2e6', paddingTop: '16px' }}>
                                <div className="d-flex align-items-center mb-3">
                                    <input
                                        type="checkbox"
                                        id="updateReportStatus"
                                        checked={this.state.updateReportStatus}
                                        onChange={(e) => this.setState({ updateReportStatus: e.target.checked, reportStatus: '' })}
                                        style={{ marginRight: '8px' }}
                                    />
                                    <label htmlFor="updateReportStatus" style={{ marginBottom: 0, cursor: 'pointer' }}>
                                        Also update Report Status
                                    </label>
                                </div>
                                {this.state.updateReportStatus && (
                                    <>
                                        <GridAutocomplete
                                            options={reportStatusOptions}
                                            value={this.state.reportStatus}
                                            onChange={(event, newValue) => {
                                                this.setState({ reportStatus: newValue || '' });
                                            }}
                                            getOptionLabel={(option) => {
                                                if (!option) return 'None';
                                                return option.charAt(0).toUpperCase() + option.slice(1);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} variant="outlined" label="Report Status" />
                                            )}
                                        />
                                        {this.state.reportStatus === 'final' && (
                                            <div style={{ marginTop: '8px', fontSize: '13px', color: '#28a745' }}>
                                                <i className="fas fa-info-circle"></i>&nbsp;
                                                Setting to Final will regenerate PDFs without watermark and set order status to Reported for all selected orders.
                                            </div>
                                        )}
                                        {this.state.reportStatus === 'preliminary' && (
                                            <div style={{ marginTop: '8px', fontSize: '13px', color: '#fd7e14' }}>
                                                <i className="fas fa-info-circle"></i>&nbsp;
                                                Setting to Preliminary will regenerate PDFs with "PRELIMINARY" watermark.
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={this.handleSave} disabled={this.state.saving}>
                        {this.state.saving && (
                            <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }}></i>
                        )}
                        Save
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}
